import * as React from 'react';
import { cn } from '../lib/cn';

export interface StatCardProps {
  label: string;
  value: string | number;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  icon?: React.ReactNode;
  className?: string;
}

export function StatCard({ label, value, change, changeType = 'neutral', icon, className }: StatCardProps) {
  return (
    <div className={cn('rounded-xl border border-slate-200 bg-white p-5 shadow-sm', className)}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-slate-500">{label}</p>
          <p className="mt-1 text-2xl font-semibold text-slate-900">{value}</p>
          {change && (
            <p
              className={cn('mt-1 text-xs font-medium', {
                'text-green-700': changeType === 'positive',
                'text-red-700': changeType === 'negative',
                'text-slate-500': changeType === 'neutral',
              })}
            >
              {change}
            </p>
          )}
        </div>
        {icon && (
          <div className="rounded-lg bg-slate-100 p-2.5 text-slate-600">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
